var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeMasterNameUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1705_107856)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.012 14.7911C31.4718 15.7107 32.3963 16.2821 33.4246 16.2821C33.8741 16.2821 34.2384 16.6464 34.2384 17.0958V21.7395C34.2384 23.5653 33.6623 25.3046 32.5725 26.7694C31.4826 28.2342 29.9822 29.2858 28.2334 29.8104C28.1571 29.8333 28.0783 29.8448 27.9996 29.8448C27.9208 29.8448 27.842 29.8333 27.7657 29.8104C26.017 29.2858 24.5165 28.2342 23.4267 26.7694C22.3368 25.3046 21.7607 23.5653 21.7607 21.7395V17.0958C21.7607 16.6464 22.1251 16.2821 22.5745 16.2821C23.6028 16.2821 24.5273 15.7107 24.9871 14.791L25.1017 14.5619C25.2395 14.2862 25.5213 14.1121 25.8295 14.1121H30.1696C30.4778 14.1121 30.7596 14.2862 30.8975 14.562L31.012 14.7911ZM27.8078 24.0882L30.8766 21.0194C31.1944 20.7016 31.1944 20.1863 30.8768 19.8685C30.559 19.5507 30.0437 19.5507 29.7259 19.8685L27.2325 22.362L26.2734 21.403C25.9556 21.0852 25.4403 21.0852 25.1226 21.403C24.8048 21.7208 24.8048 22.236 25.1226 22.5538L26.657 24.0882C26.8159 24.2472 27.0242 24.3266 27.2324 24.3266C27.4406 24.3266 27.6489 24.2471 27.8078 24.0882Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8077 33.4797C18.0876 33.4797 16.6883 32.0804 16.6883 30.3603C16.6883 28.6402 18.0876 27.2409 19.8077 27.2409C21.5277 27.2409 22.9271 28.6402 22.9271 30.3603C22.9271 32.0804 21.5277 33.4797 19.8077 33.4797Z",
    fill: "#1D1B18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1915 33.4797C34.4714 33.4797 33.0721 32.0804 33.0721 30.3603C33.0721 28.6402 34.4714 27.2409 36.1915 27.2409C37.9116 27.2409 39.3109 28.6402 39.3109 30.3603C39.3109 32.0804 37.9116 33.4797 36.1915 33.4797Z",
    fill: "#1D1B18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5191 33.7418C38.6618 34.5856 37.4864 35.1071 36.1914 35.1071C34.8942 35.1071 33.7172 34.5839 32.8595 33.7377C32.4042 34.0657 31.999 34.4591 31.6586 34.9054L32.1057 35.2971C33.461 36.4841 34.2383 38.1945 34.2383 39.9896V41.8884H41.0739C41.5233 41.8884 41.8877 41.5241 41.8877 41.0747V38.3621C41.8877 36.4625 40.9528 34.7773 39.5191 33.7418Z",
    fill: "#1D1B18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1113 38.3621C14.1113 36.4625 15.0462 34.7773 16.4799 33.7418C17.3372 34.5855 18.5126 35.1071 19.8076 35.1071C21.1048 35.1071 22.2819 34.5839 23.1395 33.7377C23.5948 34.0657 24 34.4591 24.3404 34.9054L23.8933 35.297C22.538 36.4841 21.7607 38.1945 21.7607 39.9896V41.8884H14.9251C14.4757 41.8884 14.1113 41.524 14.1113 41.0746V38.3621Z",
    fill: "#1D1B18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0334 36.5214C30.2676 37.3205 29.1911 37.8196 27.9995 37.8196C26.8079 37.8196 25.7314 37.3205 24.9656 36.5214C23.9998 37.3672 23.3882 38.6079 23.3882 39.9896V41.8884H32.6108V39.9896C32.6108 38.6079 31.9992 37.3672 31.0334 36.5214Z",
    fill: "#1D1B18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4227 33.6153C25.4227 35.0362 26.5786 36.1922 27.9996 36.1922C29.4205 36.1922 30.5765 35.0362 30.5765 33.6153C30.5765 32.1943 29.4205 31.0384 27.9996 31.0384C26.5786 31.0384 25.4227 32.1943 25.4227 33.6153Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1705_107856",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMasterNameUpdate);
export default __webpack_public_path__ + "static/media/Home_Master_Name_Update.b758017873c42ce4fd98a729f43f99c7.svg";
export { ForwardRef as ReactComponent };